<template>
  <div class="statistics-back">
    <div class="ly-card hd">
      <el-select
        class="m-r-10"
        v-model="searchFormData.org_id"
        placeholder="部门"
        @change="getRootSp"
        @clear="search"
        filterable
        clearable
      >
        <el-option v-for="item in org_ids" :key="item.id" :label="item.name" :value="item.id"> </el-option>
      </el-select>
      <el-select
        v-model="searchFormData.root_specialized_subject_id"
        placeholder="项目大类"
        :disabled="!searchFormData.org_id"
        @clear="search"
        @change="getSp"
        filterable
        clearable
      >
        <el-option v-for="item in root_specialized_subject_ids" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
      <el-select
        @clear="search"
        @change="search"
        v-model="searchFormData.specialized_subject_id"
        placeholder="项目"
        filterable
        clearable
        :disabled="!searchFormData.org_id || !searchFormData.root_specialized_subject_id"
      >
        <el-option v-for="item in specialized_subject_ids" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
      <remote-search :options="teacher_ids" ref="spec" @input="value => change(value, 'teacher_ids')" :isCache="true" />
      <span>上学期</span>
      <el-select v-model="searchFormData.compare_year" placeholder="学年">
        <el-option v-for="item in years" :key="item.value" :label="item.label" :value="item.value"> </el-option>
      </el-select>
      <el-select v-model="searchFormData.compare_term" placeholder="学期">
        <el-option v-for="item in terms" :key="item.value" :label="item.label" :value="item.value"> </el-option>
      </el-select>
      <span>本学期</span>
      <el-select v-model="searchFormData.cal_year" placeholder="学年">
        <el-option v-for="item in years" :key="item.value" :label="item.label" :value="item.value"> </el-option>
      </el-select>
      <el-select v-model="searchFormData.cal_term" placeholder="学期">
        <el-option v-for="item in terms" :key="item.value" :label="item.label" :value="item.value"> </el-option>
      </el-select>
      <el-button @click="search">查询</el-button>
      <el-button type="primary" @click="exportExcel">导出</el-button>
    </div>
    <ly-table
      :getTableData="getTableData"
      :tableHeader="tableHeader"
      :searchFormData="searchFormData"
      :tableConfig="tableConfig"
      class="ly-card"
      ref="lyTable"
    >
      <template v-slot:header_old_man_count>
        老生返读人数
        <el-tooltip class="item" effect="light" content="上学期报名的学员本学期也报名" placement="top">
          <i class="el-icon-warning-outline" style="color:#e6a23c" />
        </el-tooltip>
      </template>
      <template v-slot:header_back_study_rate>
        老生返读率
        <el-tooltip class="item" effect="light" content="老生注册人数/上学期报名学员数量" placement="top">
          <i class="el-icon-warning-outline" style="color:#e6a23c"  />
        </el-tooltip>
      </template>
      <template v-slot:org_full_names="row">
       {{ row.org_full_names && row.org_full_names.replace(/中国儿童中心\/+/, '') }}
      </template>
      <template v-slot:header_compare_count>
        <div>上学期（{{ searchFormData.compare_year }}年/ {{ label(searchFormData.compare_term) }}）</div>
      </template>
      <template v-slot:header_cal_count>
        <div>本学期({{ searchFormData.cal_year }}年/ {{ label(searchFormData.cal_term) }})</div>
      </template>
      <template v-slot:back_study_rate="row">
        {{ ((row.back_study_rate || 0) * 100).toFixed(2) }} %
      </template>
    </ly-table>
  </div>
</template>
<script>
import { Select, Option, Tooltip } from 'element-ui';

import LyTable from '@/components/LyTable';
import RemoteSearch from '@/components/common/RemoteSearch';
import { report, finance } from '@/api';
import utils from '@/utils/utils';
import { teacher_ids } from '@/utils/formConfigCommon';

export default {
  name: 'statisticsBack',
  components: { ElSelect: Select, ElOption: Option, RemoteSearch, LyTable, ElTooltip: Tooltip },
  data() {
    return {
      teacher_ids: {
        ...teacher_ids.options,
        key: 'teacher_ids',
        multiple: true,
        placeholder: '教师检索',
        clearable: true,
        'collapse-tags': true
      },
      searchFormData: {
        cal_year: new Date().getFullYear(),
        cal_term: '',
        compare_year: new Date().getFullYear(),
        compare_term: '',
        teacher_ids: '',
        org_id: '',
        specialized_subject_id: '',
        root_specialized_subject_id: ''
      },
      org_ids: [],
      root_specialized_subject_ids: [],
      specialized_subject_ids: [],
      tableConfig: {
        border: true
      },
      tableHeader: [
        {
          name: '部门',
          value: 'org_full_names'
        },
        {
          name: '项目大类',
          value: 'root_specialized_subject_name'
        },
        {
          name: '项目',
          value: 'specialized_subject_name'
        },
        {
          name: '教师姓名',
          value: 'real_name'
        },
        {
          name: '2019年（上学期）',
          value: 'compare_count'
        },
        {
          name: '2019年（本学期）',
          value: 'cal_count'
        },

        {
          name: '老生返读人数',
          value: 'old_man_count'
        },
        {
          name: '老生返读率',
          value: 'back_study_rate'
        }
      ],
      getTableData: report.getBackStudyRateStatistics,
      terms: [],
      years: []
    };
  },
  mounted() {
    this.$store.dispatch('schoolYear/getTermAndYearList').then(data => {
      if (data) {
        this.years = data.year;
        this.terms = data.term;
        this.searchFormData.cal_term = data.term[0].value;
        this.searchFormData.compare_term = data.term[0].value;
        this.search();
      }
    });
    this.getOrg();
  },
  computed: {
    label() {
      return value => {
        if (value) return this.terms.find(item => item.value === value).label;
        return '';
      };
    }
  },
  methods: {
    getOrg() {
      finance.orgQuery().then(res => {
        if (res) {
          this.org_ids = res.data.list;
        }
      });
    },
    getRootSp() {
      this.searchFormData.specialized_subject_id = '';
      this.searchFormData.root_specialized_subject_id = '';
      if (this.searchFormData.org_id) {
        finance.rootSpecializedSubjectQuery({ org_id: this.searchFormData.org_id }).then(res => {
          if (res) {
            this.root_specialized_subject_ids = res.data.list;
          }
        });
      } else {
        this.root_specialized_subject_ids = [];
      }
      this.search();
    },
    getSp() {
      this.searchFormData.specialized_subject_id = '';
      if (this.searchFormData.org_id && this.searchFormData.root_specialized_subject_id) {
        finance
          .specializedSubjectQuery({
            org_id: this.searchFormData.org_id,
            root_specialized_subject_id: this.searchFormData.root_specialized_subject_id
          })
          .then(res => {
            if (res) {
              this.specialized_subject_ids = res.data.list;
            }
          });
      } else {
        this.specialized_subject_ids = [];
      }
      this.search();
    },
    change(value, key) {
      this.searchFormData[key] = value;
    },
    search() {
      this.$refs.lyTable.setData();
    },
    exportExcel() {
      const params = { ...this.searchFormData };
      Object.keys(params).forEach(key => {
        if (params[key] === '' || params[key] === null) delete params[key];
      });
      report
        .exportBackRate({
          params
        })
        .then(data => {
          if (data) utils.downloadData(data, '老师返读率统计');
        });
    }
  }
};
</script>
<style lang="less">
.statistics-back {
  .hd {
    .el-select {
      width: 100px;
    }
    .m-r-10{
      width:140px;
    }
    .ly-search-comp {
      display: inline-block;
      width: 300px;
      .el-select {
        width: 100%;
      }
      .el-input {
        width: 100%;
      }
    }
    > * {
      margin: 0 10px;
    }
  }
}
</style>
